import { Button } from '@material-ui/core'
import React from 'react'
import LogModal from 'src/components/LogModal'
import useJobLogs from 'src/hooks/useJobLogs'
import IJob from 'src/models/IJob'

interface IJobLogButtonProps {
    job: IJob
    'data-testid'?: string
}

const LogButton = ({ job, 'data-testid': testId }: IJobLogButtonProps): JSX.Element => {
    const { showLogs, logModalProps } = useJobLogs()

    return <>
        {/* an alert's action column is narrow: keep "View Log" on one line beside a long message */}
        <Button size='small' color='inherit' style={{ whiteSpace: 'nowrap' }} data-testid={testId} onClick={() => showLogs(job)}>
            View Log
        </Button>
        {logModalProps.job &&
            <LogModal
                {...logModalProps}
                job={logModalProps.job} />}
    </>
}

/*
 * "View Log" for a single job, with the log modal it opens. A connection check (Verify, Discover) is
 * left out of the pipeline's runs, so a notice of its failure is where its log is offered (MEL-702).
 * The job carries a logs link only for a workspace administrator; without one, nothing shows.
 */
const JobLogButton = (props: IJobLogButtonProps): JSX.Element | null =>
    props.job._links?.logs ? <LogButton {...props} /> : null

export default JobLogButton
